import gql from 'graphql-tag'

const query = gql`
query listProductLists {
	cashAssist {
		listProductLists {
			id
			name
		}
	}
}`

export default query
